import React, { useState, useEffect, useRef } from 'react';
import General from '../components/settings/General.js'
import Profile from '../components/settings/Profile.js'
import Filter from '../components/settings/Filter.js'
import Signature from '../components/settings/Signature.js'
import { settingCategory } from '../helper/staticHelper.js'
import { logout } from '../helper/commonHelper.js'

function Settings() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [heightToEnd, setHeightToEnd] = useState(0);
  const settingBodyRef = useRef(null);
  const components = [
    <General />,
    <Profile />,
    <Filter />,
    <Signature />
  ];

  useEffect(() => {
    const updateHeight = () => {
      setTimeout(() => calculateHeight(), 100);
    };
    updateHeight();
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  const calculateHeight = () => {
    if (settingBodyRef.current) {
      const messageSectionTop = settingBodyRef.current.getBoundingClientRect().top;
      const heightToEnd = window.innerHeight - messageSectionTop;
      setHeightToEnd(heightToEnd - 50);
    }
  };

  return (
    <>
      <div className='settings-section container-fluid'>
        <div className='settings-header-section mt-3'>
          <div className='settings-header-text'>Settings</div>
          <div className='settings-sub-header-text'>Change how your theme looks and feels</div>
        </div>
        <hr />
        <div className='settings-body-section row mt-5'>
          {/* <div className='col-2 d-flex flex-column gap-3 p-0 settings-menu-body' ref={settingBodyRef} style={{ height: `${heightToEnd}px` }}> */}
          <div className='col-2 d-flex flex-column gap-3 p-0 settings-menu-body' ref={settingBodyRef}>
            <div className='mt-5 mb-5 d-flex flex-column justify-content-center gap-3'>
              {settingCategory.map((category, index) => (
                <div className={`settings-category-list d-flex justify-content-between align-items-center height-42px cursor-pointer ${activeIndex === index ? 'active' : ''}`} key={index} onClick={() => { setActiveIndex(index); }}>
                  <span className='d-flex justify-content-center gap-2 align-items-center'>
                    {activeIndex === index ? <div className="dummy-border-append"> </div> : <div className="dummy-append"></div>}
                    <span className={`settings-list-text ${activeIndex === index ? 'gradient-text' : ''}`}>{category.name}</span>
                  </span>
                </div>

              ))}
            </div>
            <div className='d-flex justify-content-center align-items-center'>
              <button className='logout-btn cursor-pointer' onClick={()=>{
                logout();
              }}>Logout</button>
            </div>
          </div>
          {components[activeIndex]}
        </div>
      </div>
    </>
  );
}

export default Settings;
